import React, { useEffect, useRef } from 'react'
import { TelegramAuthData } from '../api/auth'

interface TelegramLoginButtonProps {
  botName: string
  onAuth: (data: TelegramAuthData) => void
  buttonSize?: 'large' | 'medium' | 'small'
  cornerRadius?: number
  requestAccess?: 'write'
  usePic?: boolean
  lang?: string
}

declare global {
  interface Window {
    TelegramLoginWidget?: {
      dataOnauth: (user: TelegramAuthData) => void
    }
  }
}

const TelegramLoginButton: React.FC<TelegramLoginButtonProps> = ({
  botName,
  onAuth,
  buttonSize = 'large',
  cornerRadius = 10,
  usePic = true,
  lang = 'ru',
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Define callback function
    const callbackName = 'TelegramLoginWidget_onAuth'
    ;(window as any)[callbackName] = (user: TelegramAuthData) => {
      onAuth(user)
    }

    // Create script element
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?22'
    script.setAttribute('data-telegram-login', botName)
    script.setAttribute('data-size', buttonSize)
    script.setAttribute('data-radius', cornerRadius.toString())
    script.setAttribute('data-onauth', `${callbackName}(user)`)
    script.setAttribute('data-request-access', 'write')
    if (usePic) {
      script.setAttribute('data-userpic', 'true')
    }
    script.setAttribute('data-lang', lang)
    script.async = true

    // Append to container
    if (containerRef.current) {
      containerRef.current.innerHTML = ''
      containerRef.current.appendChild(script)
    }

    // Cleanup
    return () => {
      delete (window as any)[callbackName]
    }
  }, [botName, onAuth, buttonSize, cornerRadius, usePic, lang])

  return <div ref={containerRef} className="telegram-login-button" />
}

export default TelegramLoginButton
